import React from 'react';
import { Modal, Button, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const DeleteEntityModal = (props) => {

    return (
        <Modal
            className='template-modal-setting small-40'
            visible={props.visible}
            onCancel={props.onCancel}
            title={<span className="manrope f-14 lh-22 w-700 black-085">
                {props.heading}</span>}
            closable={false}
            footer={[
                <span className="justify-in-end">
                    <Button disabled={props.deletingModelLoader} className="modal-okay-gray square font-14" onClick={props.onCancel}>
                        Cancel
                    </Button>
                    <Button disabled={props.deletingModelLoader} className="modal-okay square font-14" onClick={() => props.delete_model(props.selected_id)}>
                        {props.deletingModelLoader ? <span> Deleting <LoadingOutlined spin /></span> : <span> Delete </span>}
                    </Button>
                </span>
            ]}
            centered={true}>
            <Row>
                <Col span={24}>
                    <h2 className='manrope f-14 lh-22 w-500 black-085'>{props.subText}</h2>
                </Col>
            </Row>
        </Modal>
    );
}

export default DeleteEntityModal;